import { render, staticRenderFns } from "./MostSearched.vue?vue&type=template&id=b09358f6"
import script from "./MostSearched.vue?vue&type=script&lang=js"
export * from "./MostSearched.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports